// extracted by mini-css-extract-plugin
module.exports = {"status":"styles_status__d-nXM"};